var GlobalModule,
    BaseModule;
var inline_edt_tim;

BaseModule = {

    last_request_data: null,

    data: {
        page: 1,
        limit: 20,
        order_by: 'id:desc'
    },

    import_form: function( data ) {
        var module_name = this.data.module,
            module = this;

        $( "#import-dialog" ).on( 'shown.bs.modal', function( ) {
            $( "#import-dialog .modal-footer" ).hide( );
            $( "#import-dialog" ).data( 'module', module_name );


            $( "#import-dialog .btn-ok" ).on( 'click', function( ) {

                var $files = [ ],
                    $vanity = {},
                    $types = [ ];


                $( '#import-dialog input[name="f"]' ).each( function( ) {
                    var v = $( this ).val( );
                    $files.push( v );
                } );

                $( '#import-dialog select' ).each( function( ) {
                    var v = $( this ).val( );
                    $vanity[ $( this ).attr( 'name' ) ] = $( this ).val( );
                } );

                $( "#import-dialog" ).modal( 'hide' );



                $.ajax( {
                    url: API + module.api_route + '/import',
                    data: {
                        files: $files,
                        vanity: $vanity
                    },
                    type: 'PUT',
                    error: function( ) {

                        GlobalModule.show_message( 'danger', 'Something went wrong' );

                    },
                    success: function( data ) {


                        module.load_list( );

                        GlobalModule.show_message( 'success', 'Successfuly submited. Import information is not available' );

                    }
                } );


            } );

            initForm( '#import-dialog' );

        } ).on( 'hidden.bs.modal', function( ) {
            $( "#import-dialog" ).remove( );
            module.load_list( );

        } ).modal( 'show' );

    },

    load_entry_modal: function( id, caller ) {
        var module_name = this.data.module;
        var module = this;

        $( '#ajaxModal' ).on( 'hidden.bs.modal', function( ) {
            $( "#edit-review-dialog" ).remove( );
        } ).modal( 'show' );

        var data = {
            'module': module_name,
            'id': id,
            'view': 'review'
        };

        $.ajax( {
            url: '/partial/' + module_name + '.form',
            data: data,
            type: 'GET',
            dataType: 'html',
            success: function( data ) {
                if ( data.length > 0 ) {
                    $( '#ajaxModal .modal-body' ).html( '<div class="details-container" data-target="' + module_name + '" id="edit-review-dialog">' + data + '</div>' );

                    $( '#ajaxModal .modal-body form' ).data( 'partial', caller.closest( '[data-plg="partial"]' ) );

                    initForm( '#ajaxModal' );
                    module.after_load_entry( );
                } else {
                    GlobalModule.show_message( 'danger', data.error );
                }
            }
        } );

    },

    actions: function( action, id ) {
        "use strict";
        var module = this,
            module_name = module.data.module;

        switch ( action ) {
            case "new":
                GlobalModule.new_entry( module_name );
                break;
            case "edit":
            case "duplicate":

                GlobalModule.load_entry( id, module_name, action );
                break;
            case "delete":
                GlobalModule.delete_entry( id, module_name );
                break;
            case "delete-selected":
                var ids = [ ];
                $( 'input[name="selection[]"]:checked' ).each( function( ) {
                    ids.push( $( this ).val( ) );
                } );
                if ( ids.length > 0 ) {
                    GlobalModule.delete_entry( ids.join( ',' ), module_name );
                }
                break;
            case "show_in_grid":
            case "remove_from_grid":
            case "spotlight":
            case "unspotlight":
            case "hot":
            case "unhot":
            case "feature":
            case "unfeature":
            case "activate":
            case "cancel":
            case "deactivate":
            case "approve":
            case "reject":
            case "is_sale":
            case "unsale":
            case "make-new":
            case "make-old":

                if ( action == 'cancel' && confirm( "Are you sure you want to cancel the selected item?" ) !== true ) {
                    return false;
                }

                if ( action == 'reject' && confirm( "Are you sure you want to reject the selected item?" ) !== true ) {
                    return false;
                }

                if ( action == 'approve' && confirm( "Are you sure you want to approve the selected item?" ) !== true ) {
                    return false;
                }

                if ( action == 'activate' && confirm( "Are you sure you want to activate the selected item?" ) !== true ) {
                    return false;
                }

                if ( action == 'deactivate' && confirm( "Are you sure you want to deactivate the selected item?" ) !== true ) {
                    return false;
                }

                GlobalModule.status_update( module_name, id, action );
                break;

            case "activate-selected":
            case "deactivate-selected":
                var ids = [ ];
                $( 'input[name="selection[]"]:checked' ).each( function( ) {
                    ids.push( $( this ).val( ) );
                } );
                if ( ids.length > 0 ) {
                    GlobalModule.status_update_selected( module_name, ids.join( ',' ), action );
                }

                break;
        }
    },

    setFilter: function( f, v ) {
        "use strict";
        if ( f !== 'page' ) {
            this.data.page = 1;
        }
        this.data[ f ] = v;
        this.load_list( );
        return false;
    },

    after_load_entry: function( ) {
        "use strict";

        this.save( );
    },
    onImageError: function( ) {
        var src = $( this ).attr( 'src' );
        $( this ).attr( 'src', src );
        $( this ).off( 'error' );

    },
    after_load_list: function( ) {
        var module_name = this.data.module,
            module = this;

        $( '.list-container[data-target="' + module_name + '"]' ).on( 'item-selected', function( $e, data, is_checked ) {

            var selection_container = $( this ).closest( ".modal-body" ).data( 'selectioncontainer' );
            var cb = $( this ).closest( ".modal-body" ).data( 'cb' );

            if ( is_checked === true ) {

                if ( selection_container != null ) {

                    var sm = $( this ).closest( ".modal-body" ).data( 'sm' ),
                        selection_name = $( this ).closest( ".modal-body" ).data( 'selectionname' ),
                        selection_markup = $( sm ).html( );

                    for ( var i in data ) {

                        var counter = 0;

                        while ( selection_markup.indexOf( 'data.' + i ) != -1 && counter++ < 5000 ) {
                            selection_markup = selection_markup.replace( 'data.' + i, data[ i ] );
                        }
                    }

                    var $items = $( selection_markup );

                    $items.find( 'img' ).on( 'error', module.onImageError );

                    if ( selection_name.indexOf( '[]' ) == -1 ) {
                        // NOT A MULTIPLE SELECTION. CLOSE THE MODAL
                        $( selection_container ).html( $items );
                        $( this ).closest( ".vertical-menu" ).remove( );

                    } else if ( $( selection_container ).data( 'plg' ) == 'masonry' ) {
                        $( selection_container ).append( $items ).masonry( 'appended', $items );
                    } else {
                        $( selection_container ).append( $items );
                    }

                    initForm( selection_container );

                    if ( cb != null ) {
                        cb( );
                    }
                }


            } else {
                if ( selection_container != null ) {
                    var selection_name = $( this ).closest( ".modal-body" ).data( 'selectionname' );
                    $( selection_container ).find( 'input:hidden[name="' + selection_name + '"][value="' + data.id + '"]' ).closest( '.selection-item' ).remove( );
                }
            }

        } );





    },

    deep_linking: function( path ) {
        "use strict";
        var module = this,
            path_elements = path.split( '/' );
        if ( path_elements.length === 1 ) {
            module.load_list( );
        } else if ( path_elements.length === 2 && path_elements[ 1 ] === 'new' ) {
            module.actions( 'new' );
        } else if ( path_elements.length === 2 && path_elements[ 1 ] > 0 ) {
            module.actions( 'edit', path_elements[ 1 ] );
        }
    },

    load_list: function( objectt ) {
        "use strict";

        var module = this,
            module_name = module.data.module,
            request_data = $.extend( {}, module.last_request_data, {
                intent: 'load-list'
            }, objectt, module.data ),
            filter_data = $( '.filters[data-module="' + module_name + '"]' ).serializeArray( );


        if ( typeof( objectt ) !== 'undefined' && typeof( objectt.view ) !== 'undefined' ) {
            request_data.view = objectt.view;
        }
        $( '.global-progress' ).remove( );
        $( 'body' ).prepend( '<div class="global-progress progress" style="    z-index: 9999;    position: fixed;    top: 0;    right: 0;    width: 100%;"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div></div>' )

        if ( typeof( objectt ) !== 'undefined' && typeof( objectt.view ) !== 'undefined' && objectt.view == 'order' ) {
            filter_data = {};
        }
        for ( var i in filter_data ) {
            var name = filter_data[ i ].name,
                value = filter_data[ i ].value;
            if ( value === '' ) {
                if ( typeof( request_data[ name ] ) !== 'undefined' ) {
                    delete request_data[ name ];
                }
            } else {
                request_data[ name ] = value;

            }
        }

        var $list_container = $( '.list-container[data-target="' + module_name + '"]' );

        if ( typeof( objectt ) !== 'undefined' && typeof( objectt.view ) !== 'undefined' && objectt.view == 'order' ) {
            $list_container = $( '.modal .list-container[data-target="' + module_name + '"]' );
        } else if ( typeof( objectt ) !== 'undefined' && typeof( objectt.display_view ) !== 'undefined' && objectt.display_view == 'popup' ) {
            $list_container = $( '.vertical-menu .list-container[data-target="' + module_name + '"]' );
        }




        $( '.page-header[data-target="' + module_name + '"]' ).show( );
        $( '.' + module_name + '-filters' ).show( );
        $( '.details-container[data-target="' + module_name + '"]' ).hide( );

        module.last_request_data = request_data;

        $list_container.off( 'item-selected' );

        if ( typeof( objectt ) !== 'undefined' && typeof( objectt.reset_request ) !== 'undefined' ) {
            //request_data.show_in = null;          
        }


        $.ajax( {
            url: API + module.api_route,
            data: request_data,
            error: function( ) {
                $( '.global-progress' ).remove( );
                delete module.data[ 'no-cache' ];
                $( '.list-container[data-target="' + module_name + '"]' ).html( '<div class="alert alert-danger">Ooops...something went wrong</div>' );

            },
            success: function( data ) {
                $( '.global-progress' ).remove( );
                $( '.' + module_name + '-filters' ).replaceWith( data.filters );
                $( '.' + module_name + '-filters' ).show( );
                var $items = $( data.markup );
                $items.find( 'img' ).on( 'error', module.onImageError );
                $list_container.html( $items );

                var checked = [ ];
                $( '.related-' + module_name + '-list input[name="' + module_name + '[]"]' ).each( function( ) {
                    checked.push( $( this ).val( ) );
                } );

                $list_container.find( 'input.selectable-item:checkbox' ).each( function( ) {
                    var id = $( this ).val( );
                    $( this ).attr( 'checked', checked.indexOf( id ) != -1 );
                } );

                $list_container.find( 'input.selectable-item:checkbox' ).on( 'change', function( ) {
                    var checked = $( this ).is( ":checked" ),
                        caller = $( this ).closest( '.list-container[data-target="' + module_name + '"]' ),
                        all_data = $( this ).data( );

                    setTimeout( function( ) {
                        caller.trigger( 'item-selected', [ all_data, checked ] );
                    }, 10 );

                } );


                initForm( '.list-container[data-target="' + module_name + '"]' );
                initForm( '.filters-form' );

                module.after_load_list( );

            }
        } );
    },

    cropper: function( $source, $width, $height, t, prv ) {

        var module_name = this.data.module,
            module = this,
            b = $( 'body' );

        if ( $( '.crop-modal' ).length === 0 ) {
            var $markup = '<div class="modal fade modal-fade-in-scale-up show crop-modal" role="dialog" aria-labelledby="myModalLabel" style="z-index: 999999">\
                            <div class="modal-dialog modal-lg" role="document">\
                            <div class="modal-content">\
                                <div class="modal-header">\
                                    <h4 class="modal-title" id="myModalLabel">Cropper</h4>\
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\
                                </div>\
                                <div class="modal-body">\
                                    <div>\
                                    <img data-plg="cropper" data-target="input[data-name=\'file_id_crop\']" class="img-fluid" data-width="' + $width + '" data-height="' + $height + '" src="' + $source + '" />\
                                    </div>\
                                    <hr>\
                                        <button type="button" class="btn btn-default btn-sm apply-btn">Apply Crop Transformation</button>\
                                    </div>\
                                </div>\
                            </div>\
                        </div>';
            b.append( $markup );
        }

        $( '.crop-modal' ).on( 'shown.bs.modal', function( ) {

            $( '.crop-modal' ).find( '[data-plg="cropper"]' ).each( function( ) {
                var target = $( t );
                var preview_container = $( prv );
                var cl = $( this ),
                    ratio = cl.data( 'width' ) / cl.data( 'height' ),
                    $modal = cl.closest( '.modal' );
                var p = target.val( );
                if ( p == '' || p == null ) {
                    p = '[]';
                }
                cl.cropper( {
                    aspectRatio: ratio,
                    data: JSON.parse( p )
                } );

                $modal.find( '.apply-btn' ).off( 'click' );
                $modal.find( '.apply-btn' ).on( 'click', function( ) {
                    var c = $modal.find( '[data-plg="cropper"]' );
                    var transformation = c.cropper( 'getData' );

                    transformation.preview_width = c.cropper( 'getContainerData' ).width;
                    var preview = preview_container.data( 'src' );

                    if ( preview.indexOf( '?v=' ) != -1 ) {
                        preview += '&transformation=' + JSON.stringify( transformation );
                    } else {
                        preview += '?transformation=' + JSON.stringify( transformation );
                    }

                    $( target ).val( JSON.stringify( transformation ) );

                    preview_container.on( 'load', function( ) {
                        $( this ).closest( '.details' ).removeClass( 'loading' );
                    } ).attr( 'src', preview ).closest( '.details' ).addClass( 'loading' );

                    $modal.modal( 'hide' );
                } );

            } );



        } ).on( 'hidden.bs.modal', function( ) {

            $( this ).find( '.apply-btn' ).off( 'click' );
            $( this ).find( '[data-plg="cropper"]' ).cropper( 'destroy' );

            $( '.crop-modal' ).remove( );

        } ).modal( 'show' );

    },

    load_list_dialog: function( sm, selection_name, selection_container, t, cb ) {
        var module_name = this.data.module,
            module = this,
            b = $( 'body' );

        var title = t || module_name.toUpperCase( );
        if ( $( '#' + module_name + '-dialog-list' ).length === 0 ) {
            b.append( '<div id="' + module_name + '-dialog-list" class="vertical-menu" style="z-index:9999;padding:0;right: 0;width:750px;    background: #fff;    overflow-y: auto;overflow-x: hidden;">\
                <div class="clearfix p-3 bg-dark"><h4 class="text-white modal-title float-left ">' + title + '</h4>\
                <button type="button" class="btn btn-dark float-right" onclick="$(\'#' + module_name + '-dialog-list\').remove();" aria-hidden="true" class="btn btn-icon">Close <i class=\'bx bx-x\'></i></button></div>\
                <div class="modal-body" style="padding:0;">\
                </div></div>' );
        }

        $( "#" + module_name + "-dialog-list .modal-body" ).data( 'sm', sm );
        $( "#" + module_name + "-dialog-list .modal-body" ).data( 'selectionname', selection_name );
        $( "#" + module_name + "-dialog-list .modal-body" ).data( 'selectioncontainer', selection_container );
        $( "#" + module_name + "-dialog-list .modal-body" ).data( 'cb', cb );

        $( "#" + module_name + "-dialog-list .modal-body" ).html( '<div class="' + module_name + '-form"></div>' +
            '<div class="row" >' +
            '<div class="col" >' +
            '<div class="' + module_name + '-list list-container" data-target="' + module_name + '"><span class="spinner"><i class="fa fa-spinner fa-spin"></i> Loading</span></div>' +
            '<div class="details-container" data-target="' + module_name + '"></div>' +
            '</div>' +
            '<div class="col-lg-3 col-xl-2 d-none" >' +
            '<div class="' + module_name + '-filters"><span class="spinner"><i class="fa fa-spinner fa-spin"></i> Loading</span></div>' +
            '</div>' +
            '</div>' );

        module.load_list( {
            display_view: 'popup'
        } );

    },

    load_order_dialog: function( t ) {
        var module_name = this.data.module,
            module = this,
            b = $( 'body' );
        module.data.page = 1;

        var title = t || module_name.toUpperCase( );
        if ( $( '#' + module_name + '-dialog-list' ).length === 0 ) {

            b.append( '<div id="' + module_name + '-dialog-list" class="modal fade modal-fade-in-scale-up show" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">\
                        <div class="modal-dialog modal-full" style="width: 96%;max-width: 100%;" >\
                            <div class="modal-content">\
                                <div class="modal-header">\
                                    <h4 class="modal-title " style="float:left">' + title + '</h4>\
                                    <button type="button"  style="float:right" class="close" data-dismiss="modal" aria-hidden="true">×</button>\
                                </div>\
                                <div class="modal-body"></div>\
                            </div>\
                        </div>\
                    </div>' );
        }

        $( "#" + module_name + "-dialog-list" ).on( 'shown.bs.modal', function( ) {

            $( "#" + module_name + "-dialog-list .modal-body" ).html( '<div class="' + module_name + '-form"></div><div class="' + module_name + '-list list-container" data-target="' + module_name + '"><span class="spinner"><i class="fa fa-spinner fa-spin"></i> Loading</span></div>' );


            module.data.view = 'order';
            module.data.display_view = 'popup';
            module.data[ 'intent-action' ] = 'update-order';

            module.load_list( {
                display_view: 'popup',
                'view': 'order',
                'intent-action': 'update-order'
            } );


        } ).on( 'hidden.bs.modal', function( ) {

            var m = module_name.split( '-' );


            window[ ucwords( m ) ].data.page = 0;
            window[ ucwords( m ) ].data.parent = null;
            window[ ucwords( m ) ].data.category_id = null;


            window[ ucwords( m ) ].data.view = 'list';
            window[ ucwords( m ) ].data.display_view = null;
            window[ ucwords( m ) ].data[ 'intent-action' ] = null;
            window[ ucwords( m ) ].load_list( {
                reset_request: true
            } );



            $( "#" + module_name + "-dialog-list .modal-body" ).data( 'sm', null );
            $( "#" + module_name + "-dialog-list .modal-body" ).data( 'selectionname', null );
            $( "#" + module_name + "-dialog-list .modal-body" ).data( 'selectioncontainer', null );

            $( "#" + module_name + "-dialog-list" ).remove( );

        } ).modal( 'show' );
    },

    save: function( ) {

        var module_name = this.data.module,
            module = this,
            $form = $( '.details-container[data-target="' + module_name + '"] form' );

        $form.parsley( ).on( 'form:submit', function( e ) {

            $( '.global-progress' ).remove( );
            $( 'body' ).prepend( '<div class="global-progress progress" style=" z-index: 9999;    position: fixed;    top: 0;    right: 0;    width: 100%;"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div></div>' )


            if ( module.before_save ) {
                module.before_save( );
            }

            setTimeout( function( ) {

                $form.closest( '.details-container' ).find( 'button[type="submit"]' ).html( 'Working On It' ).attr( 'disabled', true ).addClass( 'disabled' ).addClass( 'disabled' );

                $.ajax( {
                    url: API + $form.find( 'input[name="route"]' ).val( ),
                    data: $form.serialize( ),
                    type: 'POST',
                    error: function( ) {
                        $form.closest( '.details-container' ).find( 'button[type="submit"]' ).removeAttr( 'disabled' ).removeClass( 'disabled' );
                        GlobalModule.show_message( 'danger', 'Something went wrong' );
                        $( '.global-progress' ).remove( );
                    },
                    success: function( data ) {
                        $( '.global-progress' ).remove( );
                        if ( data.success ) {
                            if ( $form.closest( '.modal' ).length > 0 ) {
                                $( 'body' ).removeClass( 'modal-open' );

                                $form.closest( '.modal' ).modal( 'hide' );
                                if ( module.after_save_entry ) {
                                    module.after_save_entry( );
                                }
                            } else if ( $form.data( 'partial' ) ) {


                                load_partial( $form.data( 'partial' ) );
                                $( '#ajaxModal' ).modal( 'hide' );


                            } else {

                                window.history.pushState( {}, '', '/' + module_name );
                                $( 'body' ).removeClass( 'modal-open' );
                                module.data[ 'no-cache' ] = 1;
                                module.load_list( );
                                if ( module.after_save_entry ) {
                                    module.after_save_entry( );
                                }
                            }

                        } else {
                            GlobalModule.show_message( 'danger', data.error );
                        }

                    }
                } );
            }, 300 );

            return false;

        } );
    }

};


GlobalModule = {

    alertTimeout: null,
    $body: null,

    paginate: function( page, module_name ) {
        var m = module_name.split( '-' );
        window[ ucwords( m ) ].data.page = page;
        window[ ucwords( m ) ].load_list( );
    },

    new_entry: function( module, action ) {
        var m = module.split( '-' );
        $( '.' + module + '-wrapper' ).hide( );

        $.ajax( {
            url: API + window[ ucwords( m ) ].api_route,
            data: {
                intent: 'new-entry',
                module: module
            },
            success: function( data ) {

                $( '.page-header' ).hide( );

                $( '.' + module + '-filters' ).hide( );
                $( '.list-container[data-target="' + module + '"]' ).empty( );
                $( '.details-container[data-target="' + module + '"]' ).html( data.markup ).show( );

                $( '.details-container[data-target="' + module + '"] form .tab-action:first' ).trigger( 'click' );

                initForm( '.details-container[data-target="' + module + '"] form' );

                if ( window[ ucwords( m ) ].after_load_entry ) {
                    window[ ucwords( m ) ].after_load_entry( );
                }
            }
        } );

    },

    new_entry_modal: function( module_name, params ) {
        var b = $( 'body' );

        if ( $( '#' + module_name + '-new-dialog-form' ).length === 0 ) {

            b.append( '<div id="' + module_name + '-new-dialog-form" class="modal fade " role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">\
                        <div class="modal-dialog" style="max-width: 96%;width:96%" >\
                            <div class="modal-content modal-lg"  style="max-width: 96%;width:96%">\
                                <div class="modal-body ' + module_name + '-form details-container" data-target="' + module_name + '"  ></div>\
                            </div>\
                        </div>\
                    </div>' );
        }


        $( '#' + module_name + '-new-dialog-form' ).data( {
                'id': 0,
                'module': module_name
            } )
            .on( 'shown.bs.modal', function( ) {

                GlobalModule.new_entry( module_name );

            } ).on( 'hidden.bs.modal', function( ) {
                $( '#' + module_name + '-new-dialog-form .modal-body' ).empty( );
            } ).modal( {
                backdrop: false,
                show: true
            } );
        return false;
    },

    show_message: function( type, message, callback ) {

        switch ( type ) {
            case "success":
                break;
            case "warning":
                alert( message );
                break;
            case "error":
            case "danger":
                alert( message );
                break;
            case "info":
                alert( message );
                break;
            default:
                alert( message );
        }
    },

    load_entry: function( id, module, action, overwrites ) {
        var m = module.split( '-' );

        $( '.' + module + '-wrapper' ).hide( );

        var url = API + window[ ucwords( m ) ].api_route + '/' + id;

        if ( window[ ucwords( m ) ].data.details_with ) {
            url += '/' + window[ ucwords( m ) ].data.details_with;
        } else if ( window[ ucwords( m ) ].data.list_with ) {
            url += '/' + window[ ucwords( m ) ].data.list_with;
        } else if ( window[ ucwords( m ) ].data.with ) {
            url += '/' + window[ ucwords( m ) ].data.with;
        }

        if ( action != 'duplicate' ) {

            window.history.pushState( {}, '', '/' + module + '/' + id );
        }

        window[ ucwords( m ) ].data[ 'no-cache' ] = 1;

        // $('.list-container[data-target="'+module+'"]').prepend('<div class="progress" style="position:absolute;top:0;left:0;right:0;z-index:9999"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div></div>');

        $.ajax( {

            url: url,

            data: {
                id: id,
                intent: action,
                module: module,
                overwrites: overwrites
            },
            success: function( data ) {

                delete window[ ucwords( m ) ].data[ 'no-cache' ];

                $( '.page-header' ).hide( );

                $( '.list-container[data-target="' + module + '"]' ).empty( );
                $( '.' + module + '-filters' ).hide( );

                $( '.details-container[data-target="' + module + '"]' ).html( data.markup ).show( );

                if ( action === 'duplicate' ) {
                    $( '.details-container[data-target="' + module + '"]  form input.disabled_hidden_value' ).remove( );
                    $( '.details-container[data-target="' + module + '"] form input' ).removeAttr( 'disabled' );
                    $( '.details-container[data-target="' + module + '"] form input[name="id"]' ).val( 0 );
                    $( '.details-container[data-target="' + module + '"] form input[name="common_id"]' ).val( 0 );
                }

                $( '.details-container[data-target="' + module + '"] form .tab-action:first' ).trigger( 'click' );

                initForm( '.details-container[data-target="' + module + '"] form' );

                var $title = '';

                if ( $( '.details-container[data-target="' + module + '"] form input[name="label"]' ).length > 0 ) {
                    $title = ' / ' + $( '.details-container[data-target="' + module + '"] form input[name="label"]' ).val( );
                } else if ( $( '.details-container[data-target="' + module + '"] form input[name="title"]' ).length > 0 ) {
                    $title = ' / ' + $( '.details-container[data-target="' + module + '"] form input[name="title"]' ).val( );
                } else if ( $( '.details-container[data-target="' + module + '"] form input[name="name"]' ).length > 0 ) {
                    $title = ' / ' + $( '.details-container[data-target="' + module + '"] form input[name="name"]' ).val( );
                } else if ( $( '.details-container[data-target="' + module + '"] form input[name="attributes[name]"]' ).length > 0 ) {
                    $title = ' / ' + $( '.details-container[data-target="' + module + '"] form input[name="attributes[name]"]' ).val( );
                }

                $( 'h2.page-title small' ).html( $title );

                if ( window[ ucwords( m ) ].after_load_entry ) {
                    window[ ucwords( m ) ].after_load_entry( );
                }
            }
        } );
    },

    delete_entry: function( id, module_name ) {
        "use strict";
        $( '#' + module_name + '-delete-dialog' )
            .data( {
                'id': id,
                'module': module_name
            } )
            .modal( {
                backdrop: false,
                show: true
            } );
        return false;
    },

    delete_entry_confirmed: function( module, id ) {
        "use strict";

        var m = module.split( '-' );
        $.ajax( {
            url: API + window[ ucwords( m ) ].api_route + '/' + id,
            data: {
                _method: 'delete'
            },
            type: 'POST',
            success: function( data ) {
                $( '#' + module + '-delete-dialog' ).modal( 'hide' );
                $( 'body' ).removeClass( 'modal-open' );

                if ( data.success ) {
                    GlobalModule.show_message( 'success', data.success );
                    window[ ucwords( m ) ].data[ 'no-cache' ] = 1;
                    window[ ucwords( m ) ].load_list( );
                } else {
                    GlobalModule.show_message( 'danger', data.error );
                }
            }
        } );
    },


    status_update_selected: function( module, id, way, mmm ) {
        "use strict";
        var m = module.split( '-' );
        var muted = mmm || false;

        $.ajax( {
            url: API + window[ ucwords( m ) ].api_route + '/status',
            method: 'POST',
            data: {
                status: way,
                id: id
            },
            success: function( data ) {

                if ( data.success ) {

                    window[ ucwords( m ) ].data[ 'no-cache' ] = 1;
                    window[ ucwords( m ) ].load_list( );

                    GlobalModule.show_message( 'success', data.success );

                } else {
                    GlobalModule.show_message( 'danger', data.error );
                }
            }
        } );
        return false;
    },

    status_update: function( module, id, way, mmm ) {
        "use strict";
        var m = module.split( '-' );
        var muted = mmm || false;

        $.ajax( {
            url: API + window[ ucwords( m ) ].api_route + '/' + id + '/status',
            data: {
                status: way,
                _method: 'put'
            },
            type: 'POST',
            success: function( data ) {

                if ( data.success ) {

                    if ( muted ) return false;

                    if ( way == 'show_in_grid' ) {
                        var mm = $( 'div[data-id="' + id + '"]' ).find( '.action-show-in-grid' ).data( 'module' );
                        $( 'div[data-id="' + id + '"]' ).find( '.action-show-in-grid' ).removeClass( 'btn-default' ).addClass( 'btn-danger' );
                        $( 'div[data-id="' + id + '"]' ).find( '.action-show-in-grid' ).attr( 'onclick', mm + ".actions('unfeature'," + id + ");return false;" );

                    } else if ( way == 'remove_from_grid' ) {
                        var mm = $( 'div[data-id="' + id + '"]' ).find( '.action-show-in-grid' ).data( 'module' );

                        $( 'div[data-id="' + id + '"]' ).find( '.action-show-in-grid' ).removeClass( 'btn-danger' ).addClass( 'btn-default' );
                        $( 'div[data-id="' + id + '"]' ).find( '.action-show-in-grid' ).attr( 'onclick', mm + ".actions('feature'," + id + ");return false;" );

                    }
                    /*else if(way == 'feature'){
                                            var mm =  $('div[data-id="'+id+'"]').find('.action-feature').data('module');
                                            $('div[data-id="'+id+'"]').find('.action-feature').removeClass('btn-default').addClass('btn-danger');
                                            $('div[data-id="'+id+'"]').find('.action-feature').attr('onclick',mm + ".actions('unfeature',"+id+");return false;");

                                        }else if(way == 'unfeature'){
                                            var mm =  $('div[data-id="'+id+'"]').find('.action-feature').data('module');

                                            $('div[data-id="'+id+'"]').find('.action-feature').removeClass('btn-danger').addClass('btn-default');
                                            $('div[data-id="'+id+'"]').find('.action-feature').attr('onclick',mm+ ".actions('feature',"+id+");return false;");

                                        }*/
                    else if ( way == 'spotlight' ) {
                        var mm = $( 'div[data-id="' + id + '"]' ).find( '.action-spotlight' ).data( 'module' );
                        $( 'div[data-id="' + id + '"]' ).find( '.action-spotlight' ).removeClass( 'btn-default' ).addClass( 'btn-danger' );
                        $( 'div[data-id="' + id + '"]' ).find( '.action-spotlight' ).attr( 'onclick', mm + ".actions('unspotlight'," + id + ");return false;" );

                    } else if ( way == 'unspotlight' ) {
                        var mm = $( 'div[data-id="' + id + '"]' ).find( '.action-spotlight' ).data( 'module' );

                        $( 'div[data-id="' + id + '"]' ).find( '.action-spotlight' ).removeClass( 'btn-danger' ).addClass( 'btn-default' );
                        $( 'div[data-id="' + id + '"]' ).find( '.action-spotlight' ).attr( 'onclick', mm + ".actions('spotlight'," + id + ");return false;" );

                    } else if ( way == 'is_sale' ) {
                        var mm = $( 'div[data-id="' + id + '"]' ).find( '.action-is-sale' ).data( 'module' );
                        $( 'div[data-id="' + id + '"]' ).find( '.action-is-sale' ).removeClass( 'btn-default' ).addClass( 'btn-danger' );
                        $( 'div[data-id="' + id + '"]' ).find( '.action-is-sale' ).attr( 'onclick', mm + ".actions('unsale'," + id + ");return false;" );

                    } else if ( way == 'unsale' ) {
                        var mm = $( 'div[data-id="' + id + '"]' ).find( '.action-is-sale' ).data( 'module' );
                        $( 'div[data-id="' + id + '"]' ).find( '.action-is-sale' ).removeClass( 'btn-danger' ).addClass( 'btn-default' );
                        $( 'div[data-id="' + id + '"]' ).find( '.action-is-sale' ).attr( 'onclick', mm + ".actions('is-sale'," + id + ");return false;" );

                    } else {
                        window[ ucwords( m ) ].data[ 'no-cache' ] = 1;
                        window[ ucwords( m ) ].load_list( );
                    }

                    GlobalModule.show_message( 'success', data.success );


                } else {
                    GlobalModule.show_message( 'danger', data.error );
                }
            }
        } );

    },

    add_location: function( t ) {
        "use strict";
        var template = t || '.item-select-template',
            html_template = $( template ).html( ),
            markup = $( '<div style="clear:both;" class="item-row">' + html_template + '</div>' );

        if ( markup.find( 'input[type="radio"]' ).length ) {
            var un_id = Math.random( ).toString( 36 ).substr( 2, 9 );
            markup.find( 'input[type="radio"]' ).each( function( ) {
                var _name = $( this ).attr( 'name' ).split( '[' );
                var name = _name.length > 1 ? _name[ 0 ] + '[' + un_id + ']' : _name;
                var input_val = $( this ).val( );
                $( this ).attr( 'id', 'inputLabel' + name + input_val );
                $( this ).attr( 'name', name );
                markup.find( 'label[for="' + $( this ).attr( 'name' ) + '"]' ).attr( 'for', name );

            } );

        }

        $( '.locations-list' ).append( markup ).fadeIn( 'slow' );

        initForm( '.locations-list .item-row:last' );

        if ( $( '.locations-list .item-row' ).length === 1 ) {
            $( '.remove-item-trigger' ).hide( );
        } else {
            $( '.remove-item-trigger' ).show( );
        }
    },

    remove_location: function( t ) {
        "use strict";
        $( t ).closest( '.item-row' ).remove( );
        if ( $( '.item-list .item-row' ).length === 1 ) {
            $( '.remove-item-trigger' ).hide( );
        } else {
            $( '.remove-item-trigger' ).show( );
        }
    },

    init: function( ) {
        "use strict";
        var module = this;

        initForm( 'body' );

        $( document ).on( 'change', '#files-dialog-list .files-list input:checkbox[name="selection[]"]', function( ) {
            setTimeout( function( ) {
                update_media_order( );
            }, 500 );

        } );

        $( document ).on( 'keyup', '.inline-edit', function( ) {
            $( this ).css( 'position', 'relative' );
            if ( inline_edt_tim != null ) {
                clearTimeout( inline_edt_tim );
            }

            var cnt = $( this );
            cnt.find( 'button' ).remove( );

            inline_edt_tim = setTimeout( function( ) {

                cnt.append( '<button style="margin-left:5px;position:absolute;right:30px;top: 50%;transform: translateY(-50%);" onclick="inline_save( $(this).closest(\'.inline-edit\') );return false;" class="btn btn-icon"><i class="mdi mdi-zip-disk" aria-hidden="true"></i></button>' );
                cnt.append( '<button style="margin-left:5px;position:absolute;right:0;top: 50%;transform: translateY(-50%);" onclick="cancel_inline_save( $(this).closest(\'.inline-edit\') );return false;" class="btn btn-icon"><i class="mdi mdi-cancel" aria-hidden="true"></i></button>' );

            }, 200 );

        } );

        $( document ).on( 'click', '.markup-to-pdf', function( ) {


            var $container = $( this ).data( 'target' ),
                $m = $( $container ).clone( );
            $m.find( '.d-pdf-none' ).remove( );
            $m.find( 'select' ).remove( );
            $m.find( 'img' ).css( 'width', '100%' );

            $m.find( '.d-none' ).removeClass( 'd-none' );
            $m = $m.html( );

            var $iframe, iframe_doc, iframe_html;

            if ( ( $iframe = $( '#download_iframe' ) ).length === 0 ) {
                $iframe = $( "<iframe id='download_iframe' style='display: none' src='about:blank'></iframe>" ).appendTo( "body" );
            }

            iframe_doc = $iframe[ 0 ].contentWindow || $iframe[ 0 ].contentDocument;
            if ( iframe_doc.document ) {
                iframe_doc = iframe_doc.document;
            }




            iframe_html = "<html><head></head><body><form method='POST' action='" + API + 'analytics/pdf' + "'>" +
                "<input type=hidden name='payload' value='" + Base64.encode( $m ) + "'/></form>" +
                "</body></html>";

            iframe_doc.open( );
            iframe_doc.write( iframe_html );
            $( iframe_doc ).find( 'form' ).submit( );

        } );

        $( document ).on( 'click', '.cropper-trigger', function( ) {
            News.cropper( $( this ).data( 'src' ), $( this ).data( 'width' ), $( this ).data( 'height' ), $( this ).data( 'target' ), $( this ).data( 'prv' ) );
            return false;
        } );

        $( document ).on( 'click', '.btn-new-entry-modal', function( ) {
            var module_name = $( this ).data( 'module' );
            module.new_entry_modal( module_name, $( this ).data( ) );
            return false;
        } );
        $( document ).on( 'click', '.btn-export', function( ) {
            var module_name = $( this ).data( 'module' );
            var m = module_name.split( '-' );

            window[ ucwords( m ) ].export( $( this ).data( ) );
            return false;
        } );
        $( document ).on( 'click', '.btn-import', function( ) {
            var module_name = $( this ).data( 'module' );
            var m = module_name.split( '-' );
            window[ ucwords( m ) ].import_form( $( this ).data( ) );
            return false;
        } );
        $( document ).on( 'click', '.btn-new-entry', function( ) {
            var module_name = $( this ).data( 'module' );
            module.new_entry( module_name, $( this ).data( ) );
            return false;
        } );
        $( document ).on( 'click', '.btn-reload-list', function( ) {
            var module_name = $( this ).data( 'module' );
            var m = module_name.split( '-' );
            window[ ucwords( m ) ].load_list( );
            return false;
        } );
        $( document ).on( 'click', '.btn-cancel-edit', function( ) {

            if ( $( this ).closest( '.modal' ) ) {
                $( this ).closest( '.modal' ).modal( 'hide' );
            }

            var module_name = $( this ).data( 'module' );
            var m = module_name.split( '-' );
            if ( typeof( window[ ucwords( m ) ].original_data ) !== 'undefined' ) {

                for ( var i in window[ ucwords( m ) ].original_data ) {
                    window[ ucwords( m ) ].data[ i ] = window[ ucwords( m ) ].original_data[ i ];
                }


            } else {
                // window[ucwords(m)].data.view = 'grid';
                window[ ucwords( m ) ].data.exclude = '';
                window[ ucwords( m ) ].data.attributes = {};
            }

            window.history.pushState( {}, '', '/' + module_name );

            window[ ucwords( m ) ].load_list( );
            $( 'body' ).removeClass( 'modal-open' );
            $( 'h2.page-title small' ).html( '' );

            return false;
        } );

        $( document ).on( 'click', '.btn-update-order', function( ) {
            var module_name = $( this ).data( 'module' );
            var m = module_name.split( '-' );
            window[ ucwords( m ) ].load_order_list( );
            return false;
        } );

        $( document ).on( 'click', '.btn-save-order', function( ) {
            var module_name = $( this ).data( 'module' );
            var m = module_name.split( '-' );
            window[ ucwords( m ) ].save_order( );
            $( 'body' ).removeClass( 'modal-open' );

            return false;
        } );

        $( document ).on( 'click', '.btn-cancel-save-order', function( ) {
            var module_name = $( this ).data( 'module' );
            var m = module_name.split( '-' );
            window[ ucwords( m ) ].data.view = 'grid';
            window[ ucwords( m ) ].data.exclude = '';
            window[ ucwords( m ) ].load_list( );
            $( 'body' ).removeClass( 'modal-open' );

            return false;
        } );

        $( document ).on( 'click', '.modal-footer .btn-delete', function( ) {

            var id = $( this ).closest( '.modal' ).data( 'id' );
            var module_name = $( this ).closest( '.modal' ).data( 'module' );
            module.delete_entry_confirmed( module_name, id );
            $( 'body' ).removeClass( 'modal-open' );

            return false;
        } );
        $( document ).on( 'click', '.modal-footer .btn-delete-filtered', function( ) {
            var module_name = $( this ).closest( '.modal' ).data( 'module' );
            var m = module_name.split( '-' );
            window[ ucwords( m ) ].delete_entry_confirmed( $( this ).closest( '.modal' ).data( ) );
            $( 'body' ).removeClass( 'modal-open' );
            return false;
        } );




        $( document ).on( 'click', '.modal-footer .btn-dismiss', function( ) {
            $( this ).closest( '.modal' ).modal( 'hide' );
            $( 'body' ).removeClass( 'modal-open' );

            return false;
        } );


        $( document ).on( 'click', '.filters:visible .btn-search-trigger', function( ) {
            var module_name = $( this ).closest( '.filters' ).data( 'module' );
            var m = module_name.split( '-' );
            window[ ucwords( m ) ].data.page = 0;
            window[ ucwords( m ) ].load_list( );
            return false;
        } );

        $( document ).on( 'click', '.filters:visible .btn-load-block-trigger', function( ) {
            var module_name = $( this ).closest( '.filters' ).data( 'module' );
            var partial = $( this ).closest( '.filters' ).data( 'partial' );
            var target = $( this ).closest( '.filters' ).data( 'target' );
            var m = module_name.split( '-' );

            var data = {
                'module': module_name,
                'action': 'get-partial-block',
                'partial': partial,
                'from': $( this ).closest( '.filters' ).find( 'input[name="from"]' ).val( ),
                'to': $( this ).closest( '.filters' ).find( 'input[name="to"]' ).val( ),
                'sales_status': $( this ).closest( '.filters' ).find( 'select[name="sales_status"] option:selected' ).val( ),
                'owner': $( this ).closest( '.filters' ).find( 'select[name="owner"] option:selected' ).val( )
            };



            $.ajax( {
                data: data,
                success: function( data ) {
                    if ( data.markup ) {
                        $( target ).html( data.markup );
                    } else {
                        GlobalModule.show_message( 'danger', data.error );
                    }
                }
            } );

            return false;
        } );
        $( document ).on( 'click', '.select-library-trigger', function( ) {

            Files.data.active_uploader = $( this ).data( 'target' );
            Files.data.select_from_library = 1;
            Files.data.view = 'list';
            Files.load_list_dialog( );
            return false;
        } );

        $( document ).on( 'keypress', ".filters:visible .input-search input", function( event ) {
            if ( event.which == 13 ) {
                var module_name = $( this ).closest( '.filters' ).data( 'module' );
                var m = module_name.split( '-' );
                window[ ucwords( m ) ].data.page = 0;
                window[ ucwords( m ) ].load_list( );
                event.preventDefault( );
            }
        } );

        $( document ).on( 'click', '.pagination  a', function( ) {
            if ( $( this ).parent( ).hasClass( 'active' ) ) return false;
            var page = $( this ).data( 'page' ),
                module_name = $( this ).closest( '.list-container' ).data( 'target' );

            module.paginate( page, module_name );
            return false;
        } );

        $( document ).on( 'change', '.selectable-all', function( ) {

            var checked = $( this ).prop( 'checked' );
            if ( checked ) {
                $( '.site-action' ).addClass( 'active' );
            } else {
                $( '.site-action' ).removeClass( 'active' );
            }

            $( this ).closest( 'table' ).find( 'input:checkbox[name="selection[]"]' ).prop( 'checked', checked );
        } );


        $( document ).on( 'change', 'select[name="actions-selected"]', function( ) {

            var action = $( this ).val( );
            if ( action !== '' ) {
                var module_name = $( this ).data( 'module' );
                var m = module_name.split( '-' );
                window[ ucwords( m ) ].actions( action );
            }

        } );
        /*
                  var drake = dragula({
                      isContainer: function (el) {
                        return el.classList.contains('dragula-container');
                      }
                    });*/

        $( document ).on( 'click', '.check-all', function( ) {
            if ( $( this ).hasClass( 'checked' ) ) {
                $( this ).removeClass( 'checked' )
                $( this ).closest( 'table' ).find( 'input:checkbox[name="selection[]"]' ).prop( 'checked', false );
            } else {
                $( this ).addClass( 'checked' )
                $( this ).closest( 'table' ).find( 'input:checkbox[name="selection[]"]' ).prop( 'checked', true );
            }

        } );

        $( document ).on( 'submit', '.filters-form', function( ) {
            var m = $( this ).data( 'module' ).split( '-' );
            window[ ucwords( m ) ].data.page = 0;
            window[ ucwords( m ) ].load_list( );
            return false;
        } );

        module.$body = $( 'body' );
    }
}


function update_media_order( ) {
    $( ".related-files-list" ).sortable( );
    $( ".related-files-list" ).disableSelection( );
}

function initForm( target ) {
    if ( $( target + ' [data-plg="currenttime"]' ) ) {
        $( target + ' [data-plg="currenttime"]' ).each( function( ) {
            var $this = $( this );
            $this.data( 'plg', false );
            setInterval( function( ) {
                $this.text( moment( ).tz( $this.data( 'timezone' ) ).format( $this.data( 'format' ) ) );
            }, 500 );
        } );

    }



    $( target + ' [data-plg="daterange"]' ).daterangepicker( {
        "showDropdowns": true,
        "showWeekNumbers": true,
        "showISOWeekNumbers": true,
        "autoApply": true,
        "autoUpdateInput": false,
        ranges: {
            'Custom Range': 'custom',
            'Today': [ moment( ), moment( ) ],
            'Yesterday': [ moment( ).subtract( 1, 'days' ), moment( ).subtract( 1, 'days' ) ],
            'Last 7 Days': [ moment( ).subtract( 6, 'days' ), moment( ) ],
            'This Week': [ moment( ).startOf( 'week' ), moment( ) ],
            'Past Week': [ moment( ).subtract( 1, 'week' ).startOf( 'week' ), moment( ).subtract( 1, 'weeks' ).endOf( 'week' ) ],
            'Past 2 Weeks': [ moment( ).subtract( 2, 'weeks' ).startOf( 'week' ), moment( ).subtract( 1, 'weeks' ).endOf( 'week' ) ],
            'Last 30 Days': [ moment( ).subtract( 29, 'days' ), moment( ) ],
            'This Month': [ moment( ).startOf( 'month' ), moment( ).endOf( 'month' ) ],
            'Last Month': [ moment( ).subtract( 1, 'month' ).startOf( 'month' ), moment( ).subtract( 1, 'month' ).endOf( 'month' ) ],
            'Past 3 Months': [ moment( ).subtract( 3, 'months' ).startOf( 'month' ), moment( ) ],
            'Past 6 Months': [ moment( ).subtract( 6, 'months' ).startOf( 'month' ), moment( ) ],
            'This Year': [ moment( ).startOf( 'year' ), moment( ) ],
            'Past Year': [ moment( ).subtract( 1, 'year' ), moment( ) ],
            'Past 2 Years': [ moment( ).subtract( 2, 'years' ), moment( ) ],
            'Past 3 Years': [ moment( ).subtract( 3, 'years' ), moment( ) ],
            'Past 4 Years': [ moment( ).subtract( 4, 'years' ), moment( ) ],
            'Past 5 Years': [ moment( ).subtract( 5, 'years' ), moment( ) ]
        },
        "alwaysShowCalendars": true,
        "drops": "bottom"

    }, function( start, end, label ) {
        $( target + ' [data-plg="daterange"]' ).val( start.format( 'MM/DD/YYYY' ) + ' - ' + end.format( 'MM/DD/YYYY' ) );
    } );


    $( '[data-toggle="popover"]' ).popover( );

    $( '[data-toggle="tooltip"]' ).tooltip( );



    $( '.preview-popup-video' ).mouseenter( function( ) {
            var target = $( this ).data( 'target' );
            var $id = $( this ).data( 'target-id' );
            var tag = $( this ).data( 'target-type' );
            $( '#vidBox_' + $id ).fadeIn( );
            if ( tag == 'video' ) {
                $( '#' + target ).get( 0 ).play( );
            } else {
                var iframe_src = $( '#' + target ).attr( 'src' );
                $( '#' + target ).attr( 'src', iframe_src + '&autoplay=1' );
            }

        } )
        .mouseleave( function( ) {
            var tag = $( this ).data( 'target-type' );
            var target = $( this ).data( 'target' );
            var $id = $( this ).data( 'target-id' );
            $( '#vidBox_' + $id ).fadeOut( );
            var vid = document.getElementById( target );
            if ( tag == 'video' ) {
                $( '#' + target ).get( 0 ).pause( );
                vid.currentTime = 0;
            } else {
                var iframe_src = $( '#' + target ).attr( 'src' );
                iframe_src.replace( '&autoplay=1', '' );
                $( '#' + target ).attr( 'src', iframe_src );
            }


        } );


    $( target + ' [data-plg="daterange"]' ).on( 'apply.daterangepicker', function( ev, picker ) {
        if ( $( '.filters-form:visible' ).length > 0 ) {
            $( '.filters-form:visible' ).submit( );
        }
    } );

    $( target ).find( 'input,select,textarea' ).change( function( ) {
        if ( $( target ).find( 'data-fv-field' ).length > 0 ) {
            $( target ).formValidation( );
        }
    } );


    $( target ).find( '.checkall' ).change( function( ) {
        if ( $( target ).find( 'data-fv-field' ).length > 0 ) {
            $( target ).formValidation( );
        }

    } );


    $( target + ' [data-plg="multiple-selection-actions"]' ).each( function( ) {
        var $this = $( this );
        var t = $this.data( 'target' );
        $( t ).on( 'change', function( ) {
            if ( $( t + ':checked' ).length > 0 ) {

                $this.show( );
            } else {
                $this.hide( );
            }
        } );
    } );


    if ( $( '#vimeo_form .embed-responsive' ).length ) {
        jQuery( '#vimeo_form .tab-pane .left-side, #vimeo_form .tab-pane .right-side' ).theiaStickySidebar( {
            additionalMarginTop: 100
        } );
    }

    $( target + ' [data-plg="checkall"]' ).each( function( ) {
        var $this = $( this );
        var t = $this.data( 'target' );
        $this.on( 'change', function( ) {
            $this.closest( 'table' ).find( t ).prop( 'checked', this.checked ).trigger( 'change' );
        } );
    } );

    if ( $( '.template-builder-list' ).length > 0 ) {


        $( '.modal-config' ).find( 'input,select' ).attr( 'disabled', false );


        $( '.template-builder-list .admin-ce' ).each( function( ) {
            $( this ).addClass( 'content-editable' ).attr( 'contenteditable', true );
        } );

        $( '.template-builder-list' ).find( 'input,select' ).each( function( ) {
            if ( !$( this ).hasClass( 'content-editable' ) ) {
                $( this ).attr( 'disabled', true )
            }
        } );

        $( '.template-builder-list img.admin-ce' ).each( function( ) {
            var img_c = $( this );
            if ( !img_c.hasClass( 'template-builder-loaded' ) ) {
                var id = 'partial-' + Math.floor( Math.random( ) * 1000000 );
                img_c.addClass( 'template-builder-loaded' );
                if ( img_c.hasClass( 'admin-img-bg' ) ) {
                    $( '<div data-target="#' + id + '" class="bbb select-library-trigger details" style="position:absolute;bottom: 10px;z-index: 99;"><i class="bx bx-images"></i> Background Image</div>' ).insertBefore( img_c.parent( ) );
                    img_c.parent( ).parent( ).attr( 'id', id );
                    img_c.parent( ).addClass( 'details' );
                    img_c.parent( ).data( 'target', '#' + id );
                } else {
                    img_c.parent( ).addClass( 'select-library-trigger' );
                    img_c.parent( ).parent( ).attr( 'id', id );
                    img_c.parent( ).addClass( 'details' );
                    img_c.parent( ).data( 'target', '#' + id );
                }

                if ( !img_c.data( 'width' ) ) {

                    img_c.on( 'load', function( ) {
                        var img = $( this );

                        setTimeout( function( ) {

                            img.data( 'width', img.width( ) );
                            img.data( 'height', img.height( ) );

                        }, 100 );

                    } );
                }
            }


        } );

        $( '.template-builder-list iframe.admin-ce' ).each( function( ) {
            var a_c = $( this );
            if ( !a_c.hasClass( 'template-builder-loaded' ) ) {
                var base = a_c.data( 'name' );
                a_c.data( 'name', '' );
                var id = 'partial-' + Math.floor( Math.random( ) * 1000000 );
                var link = a_c.attr( 'src' );

                a_c.addClass( 'template-builder-loaded' );

                a_c.parent( ).css( 'overflow', 'visible' ).append( '<div data-toggle="modal" class=" bbb" data-backdrop="false" data-target="#linkModal' + id + '"><i class="bx bxs-cog"></i></div>' );

                var t = $( '#linkModal' ).clone( ).attr( 'id', "linkModal" + id );
                t.find( '.modal-title' ).html( 'iFrame Details' );

                t.find( 'label' ).html( 'iFrame src' );

                t.find( '.link' ).val( link ).attr( 'data-name', base );
                t.find( '.link' ).on( 'keyup', function( ) {
                    var entered = $( this ).val( );
                    a_c.attr( 'src', entered );
                } );

                t.find( '.link-label' ).closest( '.form-group' ).remove( );
                t.find( '.link-target' ).closest( '.form-group' ).remove( );
                t.insertAfter( a_c );
            }

        } );

        $( '.template-builder-list a.admin-ce' ).each( function( ) {

            var a_c = $( this );

            if ( !a_c.hasClass( 'template-builder-loaded' ) ) {
                a_c.addClass( 'template-builder-loaded' );

                a_c.attr( 'contenteditable', false ).css( 'position', 'relative' );
                var base = a_c.data( 'name' );
                a_c.data( 'name', '' );
                var id = 'partial-' + Math.floor( Math.random( ) * 1000000 );
                var link = a_c.attr( 'href' );
                var link_target = a_c.attr( 'target' ) || '_self';
                var link_label = a_c.html( );

                a_c.wrapInner( '<span></span>' ).append( '<div data-toggle="modal" class="bbb" data-backdrop="false" data-target="#linkModal' + id + '"><i class="bx bxs-cog"></i></div>' );

                var t = $( '#linkModal' ).clone( ).attr( 'id', "linkModal" + id );
                t.find( '.link' ).val( link ).attr( 'data-name', base );
                t.find( '.link-label' ).on( 'keyup', function( ) {
                    var entered = $( this ).val( );
                    a_c.find( 'span' ).html( entered );
                } );
                t.find( '.link-target' ).val( link_target ).attr( 'data-name', base + '_target' );
                t.find( '.link-label' ).val( link_label ).attr( 'data-name', base + '_label' );

                if ( a_c.hasClass( 'no-label' ) ) {
                    t.find( '.link-label' ).closest( '.form-group' ).remove( );
                }

                t.insertAfter( a_c );
            }

            $( '.template-builder-list a.admin-ce' ).click( function( $e ) {
                $e.preventDefault( );
            } );

        } );

    }



    if ( target == 'body' && $( target + ' [data-plg="slidePanel"]' ).length > 0 ) {

        $( document ).on( 'click', target + ' [data-plg="slidePanel"]', function( ) {

            var partial = $( this ).attr( 'href' );
            var m = $( this ).data( 'module' ).split( '-' );

            $.slidePanel.show( {

                url: partial + '?' + $.param( window[ ucwords( m ) ].last_request_data ),
                settings: {
                    method: 'GET',
                    dataType: 'html'
                }
            }, {
                skin: 'site-sidebar',
                classes: {
                    base: 'slidePanel',
                    show: 'slidePanel-show',
                    loading: 'slidePanel-loading',
                    content: 'slidePanel-content',
                    dragging: 'slidePanel-dragging',
                    willClose: 'slidePanel-will-close'
                },
                mouseDragHandler: null,
                mouseDrag: false,
                touchDrag: true,

                pointerDrag: false,
                closeSelector: '.slidePanel-close',
                useCssTransforms3d: false,
                useCssTransforms: false,
                loading: {
                    template: function( options ) {
                        return '<div class="' + options.classes.loading + '"><div class="spinner"></div></div>';
                    }
                },
                afterShow: function( ) {

                },
                afterLoad: function( ) {
                    initForm( '.slidePanel-show .slidePanel-inner-section' );
                }
            } );

            return false;
        } );
    }


    if ( $( target + ' [data-plg="partial"]' ).length > 0 ) {
        $( target + ' [data-plg="partial"]' ).each( function( ) {
            load_partial( $( this ) );
        } );
    }

    if ( $( target + ' [data-plg="ajax-data"]' ).length > 0 ) {

        $( target + ' [data-plg="ajax-data"]' ).each( function( ) {
            var caller = $( this ),
                req = caller.data( 'attrs' );

            $.ajax( {
                url: API + req.route,

                data: req,
                type: 'GET',
                success: function( data ) {
                    for ( var i in data ) {
                        caller.find( '.data-' + i ).text( data[ i ] );
                    }
                }
            } );
        } );
    }

    if ( $( target + ' [data-plg="uploader"]' ).length > 0 ) {
        $( target + ' [data-plg="uploader"]' ).each( function( ) {
            var c = $( this );

            if ( c.data( 'single' ) ) {
                Files.singleUploader( c.attr( 'id' ) );
            } else if ( c.data( 'multiple' ) ) {
                Files.multipleUploader( c.attr( 'id' ) );
            }
            c.data( 'plg', 'uploader-initiated' );
        } );
    }

    $( target + ' input[data-plg="datepicker"]' ).datepicker( {
        mask: false,
        'format': 'yyyy-mm-dd',
    } );

    $( target + ' input[data-plugin="datetimepicker"]' ).datetimepicker( {
        mask: false,
        format: 'm/d/Y H:i',
        step: 1
    } );

    $( target + ' input[data-plg="timepicker"]' ).each( function( ) {
        var $this = $( this );
        $this.timepicker( $this.data( ) );
    } );

    if ( $( target + ' [data-plg="masonry"]' ).length > 0 ) {
        var $grid = $( target + ' [data-plg="masonry"]' ).masonry( {} );
        $grid.imagesLoaded( function( ) {
            $grid.masonry( 'layout' );
        } );
    }

    if ( $( target ).data( 'plg' ) == 'masonry' ) {
        $( target ).masonry( );
    }

    if ( $( target + ' [data-plg="tabs"]' ).length > 0 ) {

        $( target + ' [data-plg="tabs"]' ).each( function( ) {
            var c = $( this );

            c.find( 'a' ).on( 'click', function( ) {

                var t = $( this ).attr( 'href' );

                $( '.tab-pane.active' ).removeClass( 'active' );
                $( t ).addClass( 'active' );

                $( '.nav-item a.active' ).removeClass( 'active' );

                $( this ).addClass( 'active' );

                setTimeout( function( ) {
                    initForm( t );
                }, 200 );

            } );
        } );
    }
    if ( target==='.modal-config' && $( target + ' select[data-plg="select2"]' ).length > 0 ) {
    

         $( target + ' select[data-plg="select2"]' ).each( function( ) {

            var $this = $( this ),
                data = $this.data( ),
                options = {
                    width: 'resolve',
                    placeholder: "Select a value",
                    allowClear: true,
                    templateResult: function( data ) {
                        // We only really care if there is an element to pull classes from
                        if ( !data.element ) {
                            return data.text;
                        }

                        var $element = $( data.element );

                        var $wrapper = $( '<span></span>' );
                        $wrapper.addClass( $element[ 0 ].className );

                        $wrapper.text( data.text );

                        return $wrapper;
                    }
                };
            if ( data.ajax ) {
                options.ajax = {
                    url: API + data.ajax,
                    dataType: 'json',
                    delay: 50,

                    data: function( params ) {
                        var search_for = typeof( params.term ) !== 'undefined' ? params.term : '';
                        return $.extend( false, {
                            q: typeof( data.search ) != 'undefined' && typeof( search_for ) != 'undefined' ? data.search + '=@' + search_for : search_for,
                            page: params.page
                        }, data.requestData );
                    },
                    processResults: function( res, params ) {
                        params.page = params.page || 1;
                        var value_field = data.value || 'id';
                        var label_field = data.label || data.search;
                        return {
                            results: $.map( res.data, function( item ) {
                                return {
                                    all_data: item,
                                    text: item[ label_field ],
                                    id: item[ value_field ]
                                }
                            } ),
                            pagination: {
                                more: ( params.page * 30 ) < data.total_count
                            }
                        };
                    },
                    cache: true
                };
                options.minimumInputLength = 0;

                if ( $this.data( 'selected_value' ) ) {
                    var dd = {};

                    dd[ data.value || 'id' ] = $this.data( 'selected_value' );

                    $.ajax( {
                        url: API + data.ajax,
                        dataType: 'json',
                        data: dd,
                        error: function( ) {},
                        success: function( res ) {
                            var label_field = data.label || data.search;
                            var value_field = data.value || 'id';
                            $this.html( '<option value="' + res.data[ 0 ][ value_field ] + '">' + res.data[ 0 ][ label_field ] + '</option>' );
                            $this.select2( options );
                        }
                    } );
                }
            }


            $this.select2( options );


        } );
            
    }




    if ( $( target + ' select[data-plg="select2"]:visible' ).length > 0 ) {

        $( target + ' select[data-plg="select2"]:visible' ).each( function( ) {

            var $this = $( this ),
                data = $this.data( ),
                options = {
                    width: 'resolve',
                    placeholder: "Select a value",
                    allowClear: true,
                    templateResult: function( data ) {
                        // We only really care if there is an element to pull classes from
                        if ( !data.element ) {
                            return data.text;
                        }

                        var $element = $( data.element );

                        var $wrapper = $( '<span></span>' );
                        $wrapper.addClass( $element[ 0 ].className );

                        $wrapper.text( data.text );

                        return $wrapper;
                    }
                };
            if ( data.ajax ) {
                options.ajax = {
                    url: API + data.ajax,
                    dataType: 'json',
                    delay: 50,

                    data: function( params ) {
                        var search_for = typeof( params.term ) !== 'undefined' ? params.term : '';
                        return $.extend( false, {
                            q: typeof( data.search ) != 'undefined' && typeof( search_for ) != 'undefined' ? data.search + '=@' + search_for : search_for,
                            page: params.page
                        }, data.requestData );
                    },
                    processResults: function( res, params ) {
                        params.page = params.page || 1;
                        var value_field = data.value || 'id';
                        var label_field = data.label || data.search;
                        return {
                            results: $.map( res.data, function( item ) {
                                return {
                                    all_data: item,
                                    text: item[ label_field ],
                                    id: item[ value_field ]
                                }
                            } ),
                            pagination: {
                                more: ( params.page * 30 ) < data.total_count
                            }
                        };
                    },
                    cache: true
                };
                options.minimumInputLength = 0;

                if ( $this.data( 'selected_value' ) ) {
                    var dd = {};

                    dd[ data.value || 'id' ] = $this.data( 'selected_value' );

                    $.ajax( {
                        url: API + data.ajax,
                        dataType: 'json',
                        data: dd,
                        error: function( ) {},
                        success: function( res ) {
                            var label_field = data.label || data.search;
                            var value_field = data.value || 'id';
                            $this.html( '<option value="' + res.data[ 0 ][ value_field ] + '">' + res.data[ 0 ][ label_field ] + '</option>' );
                            $this.select2( options );
                        }
                    } );
                }
            }


            $this.select2( options );


        } );
    }
    if ( $( target + ' .wysiwyg-inline' ).length > 0 ) {

        $( target + ' .wysiwyg-inline' ).each( function( ) {
            try {
                var id = 'partial-' + Math.floor( Math.random( ) * 1000000 );
                $( this ).attr( 'id', id );


                CKEDITOR.inline( id, {
                    allowedContent: true,
                    extraAllowedContent: 'script',
                    entities_greek: false
                } );
            } catch ( Error ) {}

        } )
    }

    initWYSIWYG( target );

    if ( $( target + " textarea.code-editor:visible" ).length > 0 ) {

        $( target + " textarea.code-editor.css:visible" ).each( function( ) {
            var elem = $( this );
            CodeMirror.fromTextArea( $( this )[ 0 ], {
                lineNumbers: true,
                mode: "css",
                viewportMargin: Infinity,
                foldGutter: true,
                gutters: [ "CodeMirror-linenumbers", "CodeMirror-foldgutter" ]

            } ).on( 'change', function( editor ) {
                elem.val( editor.getValue( ) );
            } );
        } );

        $( target + " textarea.code-editor.html:visible" ).each( function( ) {
            var elem = $( this );
            CodeMirror.fromTextArea( $( this )[ 0 ], {
                lineNumbers: true,
                mode: "htmlembedded",
                viewportMargin: Infinity,
                foldGutter: true,
                gutters: [ "CodeMirror-linenumbers", "CodeMirror-foldgutter" ]

            } ).on( 'change', function( editor ) {
                elem.val( editor.getValue( ) );
            } );
        } );

        $( target + " textarea.code-editor.js:visible" ).each( function( ) {
            var elem = $( this );

            CodeMirror.fromTextArea( $( this )[ 0 ], {
                lineNumbers: true,
                viewportMargin: Infinity,
                foldGutter: true,
                gutters: [ "CodeMirror-linenumbers", "CodeMirror-foldgutter" ]
            } ).on( 'change', function( editor ) {
                elem.val( editor.getValue( ) );
            } );
        } );

    }

}

function initWYSIWYG( target ) {

    if ( $( target + " textarea.editor:visible" ).length > 0 ) {

        $( target + " textarea.editor" ).closest( 'form' ).on( 'submit', function( ) {
            for ( instance in CKEDITOR.instances )
                CKEDITOR.instances[ instance ].updateElement( );
        } );

        $( target + " textarea.editor:visible" ).each( function( ) {

            CKEDITOR.replace( $( this ).attr( 'id' ), {
                allowedContent: true,
                extraAllowedContent: 'script',
                entities_greek: false,
                on: {
                    instanceReady: function( evt ) {
                        var editor = evt.editor,
                            body = editor.document.getBody( );
                        body.setAttribute( 'class', 'skin-guide' );
                    }
                }
            } );
        } );
    }

}

function _isChar( e ) {
    if ( typeof e.which == "undefined" ) {
        return true;
    } else if ( typeof e.which == "number" && e.which > 0 ) {
        return !e.ctrlKey && !e.metaKey && !e.altKey && e.which != 8 && e.which != 9;
    }
    return false;
}

function ucwords( str ) {
    if ( typeof( str ) == 'array' || typeof( str ) == 'object' ) {
        var s = '';
        for ( var i in str ) {
            s += ( str[ i ] + '' ).replace( /^([a-z\u00E0-\u00FC])|\s+([a-z\u00E0-\u00FC])/g, function( $1 ) {
                return $1.toUpperCase( );
            } );
        }
        return s;
    } else {
        return ( str + '' ).replace( /^([a-z\u00E0-\u00FC])|\s+([a-z\u00E0-\u00FC])/g, function( $1 ) {
            return $1.toUpperCase( );
        } );
    }
}

function getToday( ) {
    return format_date( new Date( ) );
}

function getMonday( ) {
    var date = new Date( );
    var day = date.getDay( ) || 7;
    if ( day !== 1 )
        date.setHours( -24 * ( day - 1 ) );
    return format_date( date );
}

function lastDayPreviousMonth( ) {
    var d = new Date( );
    d.setDate( 0 ); // set to last day of previous month
    return format_date( d );
}

function firstDayPreviousMonth( ) {
    var d = new Date( );
    d.setDate( 0 );
    d.setDate( 1 ); // set to the first day of that month
    return format_date( d );
}

function format_date( d ) {
    var curr_date = d.getDate( );
    var curr_month = d.getMonth( ) + 1; //Months are zero based
    var curr_year = d.getFullYear( );
    return ( curr_month + "/" + curr_date + "/" + curr_year );
}

function unique_ids( $content ) {
    var uniq = Math.floor( Math.random( ) * 1000000 ),
        counter = 0;
    while ( $content.indexOf( '--unique--' ) != -1 && counter++ < 5000 ) {
        $content = $content.replace( '--unique--', 'partial-' + uniq );
    }
    return $content;
}

function serialize( obj ) {
    var str = [ ];
    for ( var p in obj )
        if ( obj.hasOwnProperty( p ) ) {
            str.push( encodeURIComponent( p ) + "=" + encodeURIComponent( obj[ p ] ) );
        }
    return str.join( "&" );
}

function load_partial( t, cb ) {
    var c = t.data( 'partial' );

    c += '?' + serialize( t.data( ) ) + '&client_id=' + active_client.id;

    var uniqid = 'partial-' + Math.floor( Math.random( ) * 1000000 );
    if ( t.hasClass( 'partial-loaded' ) ) {
        setTimeout( function( ) {
            t.removeClass( 'partial-loaded' );
        }, 3000 );
        return false;
    }

    t.addClass( 'partial-loaded' ).attr( 'id', uniqid ).load( c, function( ) {
        initForm( '#' + uniqid );

        if ( typeof( cb ) !== 'undefined' ) {
            cb( );
        }

    } );
}


function scroll2element( el ) {
    $( 'html, body' ).animate( {
        scrollTop: $( el ).offset( ).top
    }, 1000 );
}

$( document ).ready( function( ) {
    GlobalModule.init( );

    initMetisMenu( );
    initLeftMenuCollapse( );
    initActiveMenu( );
    initMenuItem( );
    initFullScreen( );
    initRightSidebar( );
    initDropdownMenu( );
    initComponents( );
} );


function cancel_inline_save( container ) {
    var initialValue = container.data( 'initialValue' );
    container.blur( );
    container.text( initialValue );

}

function inline_save( container ) {

    var id = container.data( 'id' );
    var key = container.data( 'field' );
    var value = container.text( ).replace( /\r?\n?/g, '' ).trim( );
    var data = {};
    var m = container.data( 'module' );
    data[ key ] = value;
    data[ '_method' ] = 'put';

    $.ajax( {
        url: API + window[ m ].api_route + '/' + id + '/quick-update',
        data: data,
        type: 'POST',
        success: function( data ) {
            container.blur( );
            container.find( 'button' ).remove( );
        }
    } );
}

function initMetisMenu( ) {
    //metis menu
    //$("#side-menu").metisMenu();
}

function initLeftMenuCollapse( ) {
    $( '#vertical-menu-btn' ).on( 'click', function( event ) {
        event.preventDefault( );
        $( 'body' ).toggleClass( 'sidebar-enable' );
        if ( $( window ).width( ) >= 992 ) {
            $( 'body' ).toggleClass( 'vertical-collpsed' );
        } else {
            $( 'body' ).removeClass( 'vertical-collpsed' );
        }
    } );
}

function initActiveMenu( ) {
    $( "#sidebar-menu a" ).each( function( ) {
        var pageUrl = window.location.href.split( /[?#]/ )[ 0 ];
        if ( this.href == pageUrl ) {
            $( this ).addClass( "active" );
            $( this ).parent( ).addClass( "mm-active" ); // add active to li of the current link
            $( this ).parent( ).parent( ).addClass( "mm-show" );
            $( this ).parent( ).parent( ).addClass( "show" );
            $( this ).parent( ).parent( ).prev( ).addClass( "mm-active" ); // add active class to an anchor
            $( this ).parent( ).parent( ).parent( ).addClass( "mm-active" );
            $( this ).parent( ).parent( ).parent( ).parent( ).addClass( "mm-show" ); // add active to li of the current link
            $( this ).parent( ).parent( ).parent( ).parent( ).addClass( "show" ); // add active to li of the current link
            $( this ).parent( ).parent( ).parent( ).parent( ).parent( ).addClass( "mm-active" );
        }
    } );
}

function initMenuItem( ) {
    $( ".navbar-nav a" ).each( function( ) {
        var pageUrl = window.location.href.split( /[?#]/ )[ 0 ];
        if ( this.href == pageUrl ) {
            $( this ).addClass( "active" );
            $( this ).parent( ).addClass( "active" );
            $( this ).parent( ).parent( ).addClass( "active" );
            $( this ).parent( ).parent( ).parent( ).addClass( "active" );
            $( this ).parent( ).parent( ).parent( ).parent( ).addClass( "active" );
            $( this ).parent( ).parent( ).parent( ).parent( ).parent( ).addClass( "active" );
        }
    } );
}

function initFullScreen( ) {
    $( '[data-toggle="fullscreen"]' ).on( "click", function( e ) {
        e.preventDefault( );
        $( 'body' ).toggleClass( 'fullscreen-enable' );
        if ( !document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement ) { // current working methods
            if ( document.documentElement.requestFullscreen ) {
                document.documentElement.requestFullscreen( );
            } else if ( document.documentElement.mozRequestFullScreen ) {
                document.documentElement.mozRequestFullScreen( );
            } else if ( document.documentElement.webkitRequestFullscreen ) {
                document.documentElement.webkitRequestFullscreen( Element.ALLOW_KEYBOARD_INPUT );
            }
        } else {
            if ( document.cancelFullScreen ) {
                document.cancelFullScreen( );
            } else if ( document.mozCancelFullScreen ) {
                document.mozCancelFullScreen( );
            } else if ( document.webkitCancelFullScreen ) {
                document.webkitCancelFullScreen( );
            }
        }
    } );
    document.addEventListener( 'fullscreenchange', exitHandler );
    document.addEventListener( "webkitfullscreenchange", exitHandler );
    document.addEventListener( "mozfullscreenchange", exitHandler );

    function exitHandler( ) {
        if ( !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement ) {
            $( 'body' ).removeClass( 'fullscreen-enable' );
        }
    }
}

function initRightSidebar( ) {
    // right side-bar toggle
    $( '.right-bar-toggle' ).on( 'click', function( e ) {
        $( 'body' ).toggleClass( 'right-bar-enabled' );
    } );

    $( document ).on( 'click', 'body', function( e ) {
        if ( $( e.target ).closest( '.right-bar-toggle, .right-bar' ).length > 0 ) {
            return;
        }

        $( 'body' ).removeClass( 'right-bar-enabled' );
        return;
    } );
}

function initDropdownMenu( ) {
    $( '.dropdown-menu a.dropdown-toggle' ).on( 'click', function( e ) {
        if ( !$( this ).next( ).hasClass( 'show' ) ) {
            $( this ).parents( '.dropdown-menu' ).first( ).find( '.show' ).removeClass( "show" );
        }
        var $subMenu = $( this ).next( ".dropdown-menu" );
        $subMenu.toggleClass( 'show' );

        return false;
    } );
}

function initComponents( ) {
    $( function( ) {
        $( '[data-toggle="tooltip"]' ).tooltip( )
    } )

    $( function( ) {
        $( '[data-toggle="popover"]' ).popover( )
    } )
}

function initPreloader( ) {
    $( window ).on( 'load', function( ) {
        $( '#status' ).fadeOut( );
        $( '#preloader' ).delay( 350 ).fadeOut( 'slow' );
    } );
}